<template>
  <component :is="file" :style="styleObj" :class="className" class="AppIcon" />
</template>

<script>
export default {
  name: 'Presenter',
  props: {
    file: {
      type: String,
      default: '',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    cursor: {
      type: String,
      default: '',
    },
  },
  computed: {
    className() {
      const className = []

      if (this.size) {
        className.push(`_${this.size}`)
      }

      return className
    },
    styleObj() {
      let cursorStyle = this.cursor
      if (cursorStyle.length === 0) {
        cursorStyle = this.clickable ? 'pointer' : 'auto'
      }
      return {
        cursor: cursorStyle,
      }
    },
  },
}
</script>
